
import {defineComponent} from "vue";
import BaseShareOverlayComponent from "@/components/share/BaseShareOverlayComponent.vue";

export default defineComponent({
    name: "MiniShareOverlayComponent",
    extends: BaseShareOverlayComponent,
});
